export const ChatButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      onClick={onClick}
      style={{
        position: 'fixed',
        bottom: '100px',
        right: '20px',
        zIndex: 1300,
        backgroundColor: '#1976d2',
        color: 'white',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        border: 'none',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
        fontSize: '24px',
        cursor: 'pointer',
      }}
    >
      💬
    </button>
  );
};
